import React from 'react';
import './IOSSpinner.css';

const IOSSpinner = ({spinnerColor="#888"}) => {
  return (
    <div className="ios-spinner">
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i}>
          <span
            style={{
              display: "block",
              position: "absolute",
              top: "0.1vh",
              left: "1.15vh",
              width: "0.2vh",
              height: "0.6vh",
              borderRadius: "20%",
              backgroundColor: spinnerColor, // ← your desired background color
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default IOSSpinner;
